module.exports = __webpack_public_path__ + "static/media/water-heater.20d468b0.png";